import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock, ShieldCheck, Zap, Lock } from 'lucide-react';
import { Button } from './ui/Button';
export function PricingSection() {
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 59,
    s: 50
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.s > 0) return {
          ...prev,
          s: prev.s - 1
        };
        if (prev.m > 0) return {
          ...prev,
          m: prev.m - 1,
          s: 59
        };
        if (prev.h > 0) return {
          ...prev,
          h: prev.h - 1,
          m: 59,
          s: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section id="pricing" className="py-12 md:py-16 bg-slate-50" data-id="element-195">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-196">
        <div className="text-center mb-8" data-id="element-197">
          <div className="inline-flex items-center justify-center gap-2 text-red-600 font-bold text-sm mb-2" data-id="element-198">
            <Clock className="w-4 h-4" data-id="element-199" />
            PRECIO DE LANZAMIENTO — CIERRA EN:
          </div>
          <div className="text-3xl font-bold font-heading text-navy mb-2" data-id="element-200">
            {String(timeLeft.h).padStart(2, '0')}
            <span className="text-slate-400 mx-1" data-id="element-201">:</span>
            {String(timeLeft.m).padStart(2, '0')}
            <span className="text-slate-400 mx-1" data-id="element-202">:</span>
            {String(timeLeft.s).padStart(2, '0')}
          </div>
          <div className="text-sm text-slate-500 mb-6" data-id="element-203">
            ⚠️ Después sube $10.000 ARS. No vuelve.
          </div>

          <h2 className="text-3xl font-bold text-navy mb-4" data-id="element-204">
            ELEGÍ TU SISTEMA
          </h2>

          <div className="max-w-xs mx-auto text-left" data-id="element-205">
            <div className="flex justify-between text-xs font-bold text-slate-500 mb-1" data-id="element-206">
              <span data-id="element-207">Cupos al precio de lanzamiento</span>
              <span data-id="element-208">72%</span>
            </div>
            <div className="h-2 bg-slate-200 rounded-full overflow-hidden" data-id="element-209">
              <motion.div initial={{
              width: 0
            }} animate={{
              width: '72%'
            }} transition={{
              duration: 1
            }} className="h-full bg-gold rounded-full" data-id="element-210" />
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-6 items-start" data-id="element-211">
          {/* Base */}
          <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-200" data-id="element-212">
            <h3 className="text-xl font-bold text-navy mb-1" data-id="element-213">
              📘 Pack Lectura Fluida (plan base)
            </h3>
            <p className="text-sm text-slate-500 mb-4" data-id="element-214">5 Tomos + 3 Bonos</p>
            <p className="text-sm text-slate-600 mb-6" data-id="element-215">
              Ideal para: Padres que quieren dejar de improvisar y acompañar con
              método desde hoy.
            </p>

            <div className="flex items-baseline gap-2 mb-6" data-id="element-216">
              <span className="text-slate-400 line-through text-sm" data-id="element-217">
                $44.920
              </span>
              <span className="text-3xl font-bold text-navy" data-id="element-218">
                $19.990 <span className="text-sm font-normal" data-id="element-219">ARS</span>
              </span>
            </div>

            <Button variant="primary" className="w-full bg-blue-600 hover:bg-blue-700" href="https://www.tupuntodigital.shop/cart/46104364679341:1" data-id="element-220">
              Lo quiero →
            </Button>
          </div>

          {/* Premium */}
          <div className="bg-white text-navy rounded-2xl p-6 shadow-xl relative border border-gold/40" data-id="element-221">
            <div className="absolute -top-3 left-6 bg-gold text-navy text-xs font-bold px-3 py-1 rounded-full" data-id="element-222">
              ⭐ El más elegido
            </div>
            <h3 className="text-xl font-bold text-gold-600 mb-1 mt-2" data-id="element-223">
              🏆 MegaPack + Kit Acelerador
            </h3>
            <p className="text-sm text-slate-500 mb-4" data-id="element-224">
              5 Tomos + 3 Bonos + Kit Acelerador
            </p>
            <p className="text-sm text-slate-600 mb-6" data-id="element-225">
              Ideal para: Padres que quieren el sistema completo con todas las
              herramientas listas desde el día 1.
            </p>

            <div className="flex items-baseline gap-2 mb-6" data-id="element-226">
              <span className="text-slate-400 line-through text-sm" data-id="element-227">
                $66.890
              </span>
              <span className="text-4xl font-bold text-navy" data-id="element-228">
                $27.990{' '}
                <span className="text-sm font-normal text-slate-500" data-id="element-229">ARS</span>
              </span>
            </div>

            <Button variant="gold" className="w-full" href="https://www.tupuntodigital.shop/cart/46104382963885:1" data-id="element-230">
              → QUIERO EL MEGAPACK
            </Button>
          </div>
        </div>

        <div className="flex justify-center gap-4 mt-8 text-xs text-slate-500 font-medium" data-id="element-231">
          <div className="flex items-center" data-id="element-232">
            <ShieldCheck className="w-3 h-3 mr-1" data-id="element-233" /> Garantía 7 días
          </div>
          <div className="flex items-center" data-id="element-234">
            <Zap className="w-3 h-3 mr-1" data-id="element-235" /> Acceso inmediato
          </div>
          <div className="flex items-center" data-id="element-236">
            <Lock className="w-3 h-3 mr-1" data-id="element-237" /> Pago seguro
          </div>
        </div>
      </div>
    </section>;
}